var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-685.000000, -336.000000) translate(430.000000, 304.000000) translate(255.000000, 32.000000) translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FFE17D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFD164"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.774 42.399c-14.36 0-26-11.641-26-26C3.774 10.18 5.96 4.474 9.601 0 3.744 4.767 0 12.032 0 20.173c0 14.36 11.64 26 26 26 8.141 0 15.405-3.744 20.173-9.602-4.474 3.642-10.18 5.828-16.399 5.828z",
    transform: "translate(0.000000, 5.827239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.452 46.173c.922 0 1.677-.755 1.677-1.678 0-.922-.755-1.677-1.677-1.677h.838c.923 0 1.678-.755 1.678-1.678 0-.922-.755-1.677-1.678-1.677h.839c.923 0 1.677-.755 1.677-1.677 0-.923-.754-1.678-1.677-1.678h9.226c.926 0 1.677-.75 1.677-1.677s-.75-1.678-1.677-1.678H14.258c-1.39 0-2.516-1.126-2.516-2.516v-5.032c0-.926-.751-1.677-1.677-1.677-.927 0-1.678.75-1.678 1.677v4.106c0 1.143-.389 2.251-1.103 3.144l-.781.977c-.952 1.19-1.47 2.668-1.47 4.191v3.518c0 2.779 2.252 5.032 5.031 5.032h8.388z",
    transform: "translate(0.000000, 5.827239)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFC350"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.097 20.968H5.032c-1.85 0-3.355-1.505-3.355-3.355v-3.518c0-1.138.392-2.254 1.103-3.143l.782-.977C4.51 8.79 5.032 7.3 5.032 5.783V0c-.926 0-1.677.751-1.677 1.677v4.106c0 1.143-.39 2.251-1.103 3.144l-.782.977C.52 11.094 0 12.572 0 14.096v3.517c0 2.78 2.253 5.032 5.032 5.032h8.387c.923 0 1.678-.755 1.678-1.677zM26 10.903H14.258c-.463 0-.839.376-.839.839 0 .463.376.839.839.839h10.064c.927 0 1.678-.751 1.678-1.678zM12.58 15.097c0 .463.376.838.84.838h1.677c.922 0 1.677-.754 1.677-1.677h-3.355c-.463 0-.838.375-.838.839z",
    transform: "translate(5.032310, 29.354857)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.742 18.452c0 .463.375.838.839.838h1.677c.923 0 1.677-.755 1.677-1.677h-3.354c-.464 0-.84.375-.84.839z",
    transform: "translate(5.032310, 29.354857)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#AA7346"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.176 24.849c-.158 0-.319-.036-.47-.112-.058-.029-5.808-2.887-12.165-3.033-.579-.013-1.037-.493-1.024-1.072.013-.58.494-1.059 1.072-1.024 6.844.157 12.81 3.13 13.061 3.257.517.26.724.89.464 1.407-.184.366-.554.577-.938.577zM10.274 3.881c-.229 0-.46-.074-.652-.227-.158-.125-3.764-2.892-8.105-.722-.516.26-1.148.048-1.406-.469-.259-.518-.05-1.147.47-1.407 5.567-2.786 10.156.804 10.349.958.452.362.525 1.021.163 1.474-.207.258-.511.393-.82.393zM22.016 5.56c-.49 0-.928-.346-1.028-.844-.113-.568.255-1.12.823-1.234l8.387-1.677c.57-.113 1.12.254 1.233.822.114.568-.254 1.12-.822 1.234l-8.387 1.677c-.07.014-.138.021-.206.021z",
    transform: "translate(9.015841, 9.747799)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7D5046",
    d: "M15.438 21.127c-1.15-.142-1.966-1.188-1.824-2.338l.205-1.665c.142-1.149 1.188-1.966 2.337-1.824 1.15.142 1.967 1.188 1.825 2.338l-.205 1.664c-.142 1.15-1.189 1.966-2.338 1.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C6846",
    d: "M16.156 15.3c-.142-.018-.283-.02-.421-.01l-.354 2.872c-.085.69.405 1.318 1.095 1.403.69.085 1.317-.405 1.402-1.095l.103-.832c.142-1.15-.675-2.196-1.825-2.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7D5046",
    d: "M32.999 22.961c-1.15-.141-1.967-1.188-1.825-2.337l.205-1.665c.142-1.15 1.189-1.966 2.338-1.824 1.15.141 1.966 1.188 1.824 2.337l-.205 1.665c-.142 1.15-1.188 1.966-2.337 1.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C6846",
    d: "M33.717 17.135c-.143-.018-.284-.02-.422-.01l-.354 2.872c-.085.69.405 1.317 1.095 1.402.69.085 1.318-.405 1.403-1.094l.102-.833c.142-1.15-.675-2.196-1.824-2.337z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.a5f828ef.svg";
export { ForwardRef as ReactComponent };